const actions = {
  RESET_FILTERS: "RESET_FILTERS",
  DO_FILTERS: "DO_FILTERS",
  SET_FROM_DATE: "SET_FROM_DATE",
  SET_TO_DATE: "SET_TO_DATE",
  setFrom: (date) => ({
    type: actions.SET_FROM_DATE,
    date,
  }),
  setTo: (date) => ({
    type: actions.SET_TO_DATE,
    date,
  }),
  reset: (date) => ({
    type: actions.RESET_FILTERS,
    date,
  }),
  doFilters: () => ({
    type: actions.DO_FILTERS,
  }),
};
export default actions;
